/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { Tooltip, Typography } from "@mui/material";
import { Cancel, CheckCircle, Pending } from "@mui/icons-material";

export function technicianTaskIcon(value: number) {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Task not complete">
                    <Cancel color="error" />
                </Tooltip>
            );
        case 1:
            return (
                <Tooltip title="Task complete">
                    <CheckCircle color="success" />
                </Tooltip>
            );
        case 2:
            return (
                <Tooltip title="Task is N/A">
                    <Typography color="info.main">N/A</Typography>
                </Tooltip>
            );
        default:
            return (
                <Tooltip title="Task is pending technician response">
                    <Pending color="info" />
                </Tooltip>
            );
    }
}
